import styled from 'styled-components';
import { Body, Caption } from 'components/Typography';
import { BKJThemeColorType } from '@bookjane2/bookjane-design-library';
import { Flex } from 'components/Flex';

export const FieldWrapper = styled(Flex)`
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const SectionWrapper = styled(Flex)`
  flex-direction: column;
  gap: 32px;
  padding: 32px 12px;
`;
export const HeadSection = styled(Flex)`
  padding: 32px;
  gap: 16px;
  align-items: flex-start;
  border-bottom: 1px solid rgba(139, 150, 163, 0.33);
`;

export const GeneralJaneWrapper = styled.div`
  margin: 0 20px;
`;
export const ContactJaneWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.Grey3};
  margin: 0 20px;
`;
export const MobileAppJaneWrapper = styled.div`
  margin: 0 20px;
`;

export const JaneAvatarWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.Grey4};
  border-radius: 50%;
`;

export const JaneName = styled(Body)`
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  ${({ theme }) => theme.fonts.PoppinsText}
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
`;
export const Text = styled.div`
  ${({ theme }) => theme.fonts.PoppinsText}
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;
export const EllipsisText = styled(Text)`
  white-space: nowrap;
  width: 310px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
export const PendingSignUpText = styled(Text)`
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  text-align: center;
  margin-left: 3px;
`;
export const H4 = styled.div`
  ${({ theme }) => theme.fonts.Poppins};
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
`;
export const EmptyWrapper = styled.span``;
export const LabelText = styled(Caption)`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
`;

export const ValueText = styled(Body)<{ marginLeft?: number; padding?: string }>`
  ${({ theme }) => theme.fonts.PoppinsText};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 16px;
  line-height: 24px;
  margin-left: ${({ marginLeft }) => (marginLeft ? `${marginLeft}px` : '0px')};
  padding: ${({ padding }) => (padding ? padding : '0')};
  font-weight: 500;
`;
export const ColorDot = styled.span<{ color: BKJThemeColorType }>`
  font-size: 2rem;
  height: 18px;
  display: flex;
  max-height: 18px;
  line-height: 18px;
  justify-content: center;
  align-items: center;
  color: ${({ theme, color }) => theme.colors[color]};
  margin-right: 3px;
`;
export const LoadingWrapper = styled.div`
  margin: 50%;
`;
export const NonAppUserWrapper = styled.div`
  position: relative;
`;

export const NonApUserTooltip = styled.div`
  background-color: transparent;
  text-decoration: none;
  min-height: 25px;
  width: 128px;
  top: 0;
  cursor: pointer;
  position: absolute;
  &:hover {
    cursor: pointer;
  }

  &:hover::after {
    ${({ theme }) => theme.typography.Caption};
    content: 'Staff will receive automated phone calls for shifts. Selecting this option will also assume 24/7 availability for this team member. Recommended for staff who do not use a mobile phone (previously called Non-Mobile user).';
    background-color: ${({ theme }) => theme.colors.Grey7};
    width: 282px;
    display: flex;
    position: absolute;
    color: white;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    padding: 8px 16px;
    border-radius: 8px;
    top: 36px;
    left: -135px;
    pointer-events: none;
    cursor: pointer;
  }
  &:hover::before {
    content: '';
    position: absolute;
    background-color: ${({ theme }) => theme.colors.Grey7};
    display: flex;
    height: 20px;
    width: 15px;
    transform: rotate(45deg);
    left: 115px;
    top: 30px;
    pointer-events: none;
    cursor: pointer;
  }
`;
